import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TT911 } from '@rsos/capstone/src/constants/capabilities';
import { RootState } from '../app';

const useIsTT911Enabled = (): boolean => {
  const currentPSAP = useSelector(
    (state: RootState) => state.psaps.currentPSAP,
  );

  const isTT911Enabled = useMemo(() => {
    return !!currentPSAP?.activeCapabilities?.[TT911];
  }, [currentPSAP]);

  return isTT911Enabled;
};

export default useIsTT911Enabled;
